import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";

const includes = [
  "Custom design for your trade",
  "Mobile + tablet optimized",
  "On-page SEO setup",
  "Click-to-call & contact forms",
  "Google Business Profile sync",
  "Fast, secure hosting",
  "Free updates for the first month",
  "Direct owner support — no agencies",
];

const scrollTo = (id) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Pricing = () => {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="py-20 md:py-28 bg-gray-50"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-widest text-blue-700 mb-3">
              Affordable, on purpose
            </div>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-gray-900">
              Built for owner-operators — not enterprise budgets.
            </h2>
            <p className="mt-5 text-gray-600 leading-relaxed">
              Most local businesses don't need a $10,000 website. They need a
              clean, fast, professional one that pays for itself in the first
              month. That's exactly what we build.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Button
                onClick={() => scrollTo("#demo")}
                className="bg-blue-700 hover:bg-blue-800 text-white h-12 px-6"
                data-testid="pricing-cta-primary"
              >
                Get my free demo
              </Button>
              <Button
                onClick={() => scrollTo("#contact")}
                variant="outline"
                className="h-12 px-6 border-gray-300"
                data-testid="pricing-cta-secondary"
              >
                Ask about pricing
              </Button>
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.5 }}
            className="lg:col-span-7 rounded-2xl bg-white border border-gray-200 p-7 md:p-10 shadow-sm"
            data-testid="pricing-card"
          >
            <div className="flex items-start justify-between flex-wrap gap-4">
              <div>
                <div className="text-sm text-gray-500">Local Business Site</div>
                <div className="font-display font-extrabold text-4xl md:text-5xl text-gray-900 mt-1">
                  One flat package.
                </div>
                <div className="text-gray-600 mt-2 max-w-md">
                  See your free demo first. Exact pricing shared along with it —
                  honest, simple, built for your size of business.
                </div>
              </div>
              <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-blue-700/10 text-blue-700 text-xs font-medium">
                No payment until you approve
              </div>
            </div>

            <div className="my-8 h-px bg-gray-100" />

            <div className="grid sm:grid-cols-2 gap-3">
              {includes.map((item) => (
                <div key={item} className="flex items-start gap-2.5 text-sm text-gray-800">
                  <div className="h-5 w-5 rounded-md bg-blue-700/10 text-blue-700 flex items-center justify-center mt-0.5 shrink-0">
                    <Check size={14} />
                  </div>
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
